export default __webpack_public_path__ + "static/media/sign in.8933d0a1.svg";